import { Component, OnInit, ViewChild } from '@angular/core'
import { MatTableDataSource } from '@angular/material/table'
import { MatSort } from '@angular/material/sort'
import { MatPaginator } from '@angular/material/paginator'
import { UnespCoreMessageService, UnespCoreUserService } from '@unesp/core'
import { UsuarioLogin } from 'src/app/models/usuario-login'
import { UnidadeUniversitaria } from 'src/app/models/unidade-universitaria'
import { Departamento } from 'src/app/models/departamento'
import { DiscenteService } from 'src/app/services/discente-service'
import { DiscenteInscricao } from 'src/app/models/discente-inscricao'
import { DataService } from 'src/app/services/data-service'

@Component({
  selector: 'app-discente-inscricao',
  templateUrl: './discente-inscricao.component.html',
  styleUrls: ['./discente-inscricao.component.css'],
  standalone: false
})
export class DiscenteInscricaoComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator
  @ViewChild(MatSort) sort!: MatSort

  colunasGrid: string[] = [
    'id',
    'nomeDisciplina',
    'codigoDisciplina',
    'cargaHoraria',
    'duracao',
    'semestre',
    'selecionado',
  ]
  dataSource: MatTableDataSource<DiscenteInscricao> = new MatTableDataSource()

  anos: number[] = []
  anoSelecionado: number = 0
  unidades: UnidadeUniversitaria[] = []
  departamentos: Departamento[] = []
  cpf: string = ''
  idUnidadeUniversitaria: number = 0
  idDepartamentoSecao: number = 0

  constructor(
    private discenteService: DiscenteService,
    private unespCoreMessageService: UnespCoreMessageService,
    private unespCoreUserService: UnespCoreUserService,
    private dataService: DataService
  ) {}

  ngOnInit(): void {
    this.anos = this.dataService.listYearsSince2022()
    this.anoSelecionado = this.dataService.getCachedYearSince2022()
    this.unespCoreUserService.user$.subscribe(user => {
      this.cpf = (user as UsuarioLogin).cpf ?? 0
      this.getUnidade()
    })
  }

  getUnidade(): void {
    this.dataService.setCachedYearSince2022(this.anoSelecionado)
    this.discenteService.listarUnidadeUniversitaria(this.anoSelecionado).subscribe(data => {
      this.unidades = data
    })
  }

  getDepartamento(): void {
    this.discenteService.listarDepartamento(this.anoSelecionado, this.idUnidadeUniversitaria).subscribe(data => {
      this.departamentos = data
    })
  }

  getData(): void {
    this.discenteService.inscricao(this.idDepartamentoSecao, this.anoSelecionado, this.cpf).subscribe(data => {
      this.dataSource = new MatTableDataSource(data)
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator
    })
  }

  search(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSource.filter = filterValue.trim().toLowerCase()
  }

  mudarSelecao(row: DiscenteInscricao): void {
    row.selecionado = !row.selecionado
    if (row.selecionado) {
      this.discenteService.incluirInscricao(this.cpf, this.anoSelecionado, row.semestre ?? 0, row).subscribe(data => {
        if (data.status === 'ok') {
          this.unespCoreMessageService.showMessageSuccess(`${row.nomeDisciplina} inscrito com sucesso`)
        } else {
          row.selecionado = !row.selecionado
          this.unespCoreMessageService.showMessageError(data.message)
        }
      })
    } else {
      this.discenteService
        .removerInscricao(this.cpf, this.anoSelecionado, row.semestre ?? 0, row.id)
        .subscribe(data => {
          if (data.status === 'ok') {
            this.unespCoreMessageService.showMessageWarning(`${row.nomeDisciplina} removida com sucesso`)
          } else {
            row.selecionado = !row.selecionado
            this.unespCoreMessageService.showMessageError(data.message)
          }
        })
    }
  }
}
